import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import Utils from 'src/app/utils';

@Component({
  selector: 'app-monitoring-home',
  templateUrl: './monitoring-home.component.html',
  styleUrl: './monitoring-home.component.scss'
})
export class MonitoringHomeComponent {

  alerts : any;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    //console.log("Home");

    this.getAlerts();
  }

  getAlerts(){

    let filter = {
      arc: true,
      limit: 30
    }

    //console.log('filter', filter);

    this.okService.get("alerts",filter)
    .subscribe((data) => {

      this.alerts = data.body;

      // console.log("alerts",data);

    });


  }
}
